module.exports = __webpack_public_path__ + "static/media/rsm-calendar-icon.8617c25a.svg";